import React from "react";
import {readableDate} from "../../../../utils";
import {Link} from "react-router-dom";

function ActiveRow({value, finance, activeTab}) {
  return (
    <tr
      className="clickable"
      onClick={() => window.open("/editvehicle/" + value.id, "_self")}
      key={value.id}
    >
      <td data-testid={"vehicle-registration"}>
        <Link to={`/editvehicle/${value.id}`}>
          <span className="registration-field">
          {value.registration}
          </span>
        </Link>
      </td>
      {activeTab === 'fleet' &&
        <td data-testid={"vehicle-fleetnum"}>{value.fleet_number}</td>
      }
      <td data-testid={"vehicle-owner"}>{value.owner ? value.owner : "None Set"}</td>
      <td data-testid={"vehicle-make"}>{value.make}</td>
      <td data-testid={"vehicle-model"}>{value.model}</td>
      <td data-testid={"vehicle-variant"}>{value.variant}</td>
      <td data-testid={"vehicle-department"}>{value.department}</td>
      <td data-testid={"vehicle-hire_customer"}>{value.hire_customer}</td>
      <td data-testid={"vehicle-key"}>{value.key ? value.key : "None Set"}</td>
      <td onClick={(e) => e.stopPropagation()}>{value.vin_number}</td>
      <td data-testid={"vehicle-tracker"}>{value.tracker ? value.tracker.imei : ""}</td>
      <td data-testid={"vehicle-type"}>{value.type}</td>
      <td data-testid={"vehicle-owner"}>{value.owner}</td>
      <td data-testid={"finance-company"}>{finance.finance_company}</td>
      <td data-testid={"vehicle-remainingcap"}>
        £
        {!finance.finance_early_settlement_date && finance.remaining_balance
          ? parseFloat(finance.remaining_balance - finance.hp_remaining_interest).toFixed(2)
          : 0.00
        }
      </td>
      <td data-testid={"vehicle-estimatedvalue"}>
        £
        {typeof finance.estimated_value === "string"
          ? finance.estimated_value
          : (finance.estimated_value || 0).toFixed(2)}
      </td>
      <td data-testid={"vehicle-purchasedate"}>{readableDate(value.purchase_date)}</td>
      <td data-testid={"vehicle-quote-status"} className={value.quote_status === "Active" ? "table-highlight-dark-red" : ""}>{value.quote_status}</td>
    </tr>
  )
}

export default ActiveRow;
